module.exports = __webpack_public_path__ + "img/logo12.5a41c674.png";